import { web } from "../middleware";

export const UserGoalApi = {
  getTargetsAndReflections: (userGoalId, payload) =>
    web(
      { url: `/user/goals/${userGoalId}/targets-reflections`, method: "GET" },
      payload,
    ),
};

export const WeeklyWarmapsApi = {
  getWeeklyWarmapsQuestions: (params) =>
    web({ url: `/v3/weekly-warmap/questions`, method: "GET" }, params),
  submitWeeklyWarmapsAnswers: (payload) =>
    web({
      url: `/v3/weekly-warmap/submit-answer`,
      method: "POST",
      data: payload,
    }),
};
